<template>
    <form ref="form" :class="formType">
        <slot />
    </form>
</template>

<script>
'use strict';

/* eslint-disable vue/require-default-prop */
import { _commons, CommonValidator, Dialogs } from '../commons-global/index';

export default {
    props: {
        formType: String,
        formNoValidate: [Boolean, String],
        validator: Object,
    },
    data() {
        return {
            validatorObject: this.validator || {},
            form: undefined,
        };
    },
    mounted() {
        Object.defineProperty(this, 'form', { value: this.$refs.form, writable: false });
        let validatorDefaults;
        if((this.formNoValidate === true) || (this.formNoValidate === 'true')) {
            validatorDefaults = {
                onsubmit: false,
            };
            $(this.form).on('submit.validate', (event) => {
                event.preventDefault();
                this.$emit('form.submit');
            });
        } else {
            validatorDefaults = {
                submitHandler: (form, event) => {
                    event.preventDefault();
                    this.$emit('form.submit');
                },
            };
        }
        const validator = $(this.form).validate(new CommonValidator(Object.assign(validatorDefaults, this.validatorObject)));
        _commons.setupAutoprettifyControls($(this.form));
        _commons.setupAutofillControls(validator);
    },
    methods: {
        resetValidator() {
            $(this.form).validate().resetForm();
        },
        resetValidatorAndForm() {
            $(this.form).validate().resetForm();
            this.form.reset();
        },
        validateForm() {
            return $(this.form).valid();
        },
        loadDialog(obj, options) {
            Dialogs.loadDialog(this.form, obj, options);
        },
        saveDialog(obj, options) {
            return Dialogs.saveDialog(this.form, obj, options);
        },
        submit() {
            $(this.form).trigger('submit');
        },
    },
};
</script>
